import { axiosFactory } from './axiosFactory'

export const axiosJWT = axiosFactory.getAxios('jwt')
